<div class="trend-chart">
  <div class="trend-chart__header">
    <div>
      <div class="trend-chart__title">{{ "data-platform.trend-title" | translate: { days: rangeDays() } }}</div>
      <div class="trend-chart__sub">{{ "data-platform.trend-sub" | translate }}</div>
    </div>
    <div class="trend-chart__pills">
      @if (latestValue() !== null) {
        <span class="legend-pill">
          {{ "data-platform.trend-today" | translate }}
          <strong>{{ latestValue() | toLocaleNumber }}</strong>
        </span>
      }
      @if (delta(); as d) {
        <span class="legend-pill" [class.legend-pill--up]="d.up" [class.legend-pill--down]="!d.up">
          <mat-icon>{{ d.up ? "arrow_upward" : "arrow_downward" }}</mat-icon>
          {{ d.up ? "+" : "-" }}{{ d.percent }}% · {{ rangeDays() }}d
        </span>
      }
      @if (fromSnapshot()) {
        <span class="legend-pill" data-test="trend-nightly">
          <mat-icon>nightlight</mat-icon>
          {{ "data-platform.reach-updated-nightly" | translate }}
        </span>
      }
      @if (estimated()) {
        <span class="legend-pill legend-pill--estimate" matTooltip="{{ 'data-platform.trend-estimated-tooltip' | translate }}">
          <mat-icon>insights</mat-icon>
          {{ "data-platform.trend-estimated" | translate }}
        </span>
      }
      @if (bestEffort()) {
        <span class="legend-pill legend-pill--warn" matTooltip="{{ 'data-platform.trend-best-effort-tooltip' | translate }}">
          <mat-icon>warning</mat-icon>
          {{ "data-platform.trend-best-effort" | translate }}
        </span>
      }
      @if (rangeChoices().length > 1) {
        <mat-button-toggle-group
          class="trend-chart__ranges"
          [hideSingleSelectionIndicator]="true"
          [value]="rangeDays()"
          (change)="selectRange($event.value)"
          data-test="trend-ranges">
          @for (choice of rangeChoices(); track choice.days) {
            <mat-button-toggle [value]="choice.days">{{ choice.label }}</mat-button-toggle>
          }
        </mat-button-toggle-group>
      }
    </div>
  </div>

  @if (loading()) {
    <div class="trend-chart__loading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  } @else if (errored()) {
    <div class="trend-chart__error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ "data-platform.trend-error" | translate }}</span>
      <button mat-stroked-button (click)="retry()">
        <mat-icon>refresh</mat-icon>
        {{ "generic.retry" | translate }}
      </button>
    </div>
  } @else if (chartConfig()) {
    <div class="trend-chart__canvas-wrap">
      <canvas
        baseChart
        [type]="'line'"
        [data]="chartConfig()!.data"
        [options]="chartConfig()!.options"
        [plugins]="chartConfig()!.plugins"
        [attr.aria-label]="'data-platform.trend-title' | translate: { days: rangeDays() }"></canvas>
    </div>
  } @else {
    <div class="trend-chart__empty">
      <mat-icon>show_chart</mat-icon>
      <span>{{ "data-platform.trend-empty" | translate }}</span>
    </div>
  }
</div>
